
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import WorkTaskKanbanColumn from '@/libs/work-tasks/components/WorkTaskKanbanColumn.vue';
import { WorkTaskKanbanColumnModel } from '@/libs/work-tasks/model/WorkTaskKanbanColumnModel';
import moment from 'moment';
import { ApplicationUserModel, PlanItemModel, TenantUserModel, ProcessTypeEnum, QueryOperator, SortOrder } from '@/libs/Api';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

import { Navigation } from 'swiper';
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import WorkTaskCreateDialog from '../components/WorkTaskCreateDialog.vue';
import iCalDialog from '../components/iCalDialog.vue';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { workTasksShowDetailsStore, WorkTasksShowDetailTypeEnum } from '@/libs/work-tasks/+state/store';
import NDialog from '@/libs/common/components/NDialog.vue';
import { AuditModel } from '@/libs/Api';
import { PermissionTypeEnum } from '@/libs/Api';
import { auditsStore } from '@/libs/audits/+state/store';
import ApiService from '@/libs/core/api-service';

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512): Blob => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
};

@Component({
    components: {
        WorkTaskKanbanColumn,
        Swiper,
        SwiperSlide,
        iCalDialog,
        WorkTaskCreateDialog,
        NDialog,
    },
    directives: {
        swiper: directive,
    },
    computed: {
        WorkTasksShowDetailTypeEnum() {
            return WorkTasksShowDetailTypeEnum;
        },
    },
})
export default class WorkTasks extends Page {
    user: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    kanbanItems: WorkTaskKanbanColumnModel[] = [];
    // tableItems: any[] = [];
    currentDate: any = null;
    partyFilter: string | null = null;
    districtFilter: string | null = null;
    townFilter: string | null = null;
    userFilter: string | null = null;
    dateFilter: any = null;
    tab = 'table';
    since = new Date();
    until = new Date();
    mobileFiltersShow = false;
    pagingChanged = false;
    pageIndex = 1;
    pageSize = 25;
    filterOnlyMine = true;
    filterDepartment: Array<string> | null = null;
    filterPosition: Array<string> | null = null;
    filterCategory: Array<string> | null = null;
    filterTenantUser: Array<string> | null = null;
    deletePlanItemModel: PlanItemModel | null = null;
    deletePlanItemDialog = false;
    sortBy = 'time';
    sortDesc = true;
    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    deactivatePlanItemDialog = false;
    reactivatePlanItemDialog = false;
    deactivatePlanItemModel: PlanItemModel | null = null;
    reactivatePlanItemModel: PlanItemModel | null = null;
    deactivateLoading = false;
    reactivateLoading = false;
    downloading = false;

    // Přidávám cache pro audity, abychom nemuseli opakovaně načítat stejný audit
    private auditsCache: { [key: string]: AuditModel } = {};

    // Kontrola oprávnění pro deaktivaci/reaktivaci
    canEditAudit(audit: AuditModel | undefined | null): boolean {
        if (!audit) return false;
        const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
        // Pokud má uživatel EditAllAudits, může vždy
        if (permissions && permissions.includes(PermissionTypeEnum.EditAllAudits)) return true;
        // Pokud má EditOwnedAudit, musí být owner
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser);
        if (permissions && permissions.includes(PermissionTypeEnum.EditOwnedAudit) && audit.ownerId === tenantUser.id) {
            return true;
        }
        return false;
    }

    get tableHeaders(): any[] {
        let items = [
            { text: this.$i18n.t('common.day'), value: 'time', align: 'left' },
            { text: this.$i18n.t('workTask.audit'), value: 'party.displayName', align: 'left', sortable: false },
            { text: this.$i18n.t('common.user'), value: 'party.district.name', align: 'left', sortable: false },
            { text: this.$i18n.t('common.workplace'), value: 'workplace.name', align: 'left', sortable: false },
            { text: this.$i18n.t('common.shiftType'), value: 'shiftType.name', align: 'left', sortable: false },
            { text: this.$i18n.t('planItems.planItemState'), value: 'planItemState', align: 'left', sortable: false },
            { text: this.$i18n.t('planItems.evidenceNumber'), value: 'evidenceNumber', align: 'left', sortable: false },
        ];
        if (this.getShowInfo(WorkTasksShowDetailTypeEnum.ShowProductAuditDetails)) {
            items = [
                ...items,
                { text: this.$i18n.t('planItems.productName'), value: 'productName', align: 'left', sortable: false },
                { text: this.$i18n.t('planItems.productNumber'), value: 'productNumber', align: 'left', sortable: false },
            ];
        }
        items = [...items, { text: '', value: 'id', align: 'left', sortable: false }];
        return items;
    }

    get calendarTitleWeek(): string {
        return moment(this.currentDate).format('W.') + ' ' + this.$i18n.t('common.week');
    }

    get calendarTitleMonth(): string {
        return moment(this.currentDate).format('YYYY / MM');
    }

    get showFilterOnlyMine() {
        const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
        return permissions.contains(PermissionTypeEnum.Plan) || permissions.contains(PermissionTypeEnum.Response);
    }

    get canPerformAudit() {
        const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
        return (
            permissions.contains(PermissionTypeEnum.PerformAudit) ||
            permissions.contains(PermissionTypeEnum.ShiftWork) ||
            permissions.contains(PermissionTypeEnum.ShiftWorkLimited) ||
            permissions.contains(PermissionTypeEnum.ShiftManagement) ||
            permissions.contains(PermissionTypeEnum.PerformProductInspection)
        );
    }

    get swiperOptions(): any {
        return {
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };
    }

    items: PlanItemModel[] = [];

    @Watch('filterOnlyMine')
    @Watch('filterDepartment')
    @Watch('filterPosition')
    @Watch('filterTenantUser')
    @Watch('filterCategory')
    filtersChanged() {
        if (this.tab == 'table') {
            this.loadItems();
        }
        this.saveQuery();
    }

    @Watch('pageIndex')
    @Watch('pageSize')
    paginationChanged() {
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.loadItems();
    }

    @Watch('sortBy')
    @Watch('sortDesc')
    sortChanged() {
        this.saveQuery();
        if (this.pagingChanged) {
            this.pagingChanged = false;
            return;
        }
        this.loadItems();
    }

    get tableItems(): PlanItemModel[] {
        return planItemsStore.useGetter(CrudGetter.DataBasic, 'WorkTaskItems-' + moment(this.currentDate).format('YYYY-MM-DD'));
    }

    get totalRows(): number {
        var stats = planItemsStore.useGetter(
            CrudGetter.DataStatsBasic,
            'WorkTaskItems-' + moment(this.currentDate).format('YYYY-MM-DD')
        ) as CrudDataStats;
        return stats?.rowCount ?? 0;
    }

    get deletingPlanItem(): boolean {
        return planItemsStore.useGetter(CrudGetter.Deleting);
    }

    @Prop() tenantId!: string;
    @Ref() kanbanColumns!: WorkTaskKanbanColumn[];
    @Ref() calendarDialog!: iCalDialog;
    @Ref() mySwiper!: any;

    @Watch('tab')
    tabChanged(v: string, p: string) {
        if (v != p && v == 'kanban') {
            this.makeDays();
        } else if (v != p && v == 'table') {
            this.loadItems();
        }
        if (v != p) {
            this.saveQuery();
        }
    }

    @Watch('dateFilter')
    dateFilterChanged(v: Date, p: Date) {
        if (!moment(v).isSame(moment(p))) {
            this.currentDate = v;
        }
    }

    @Watch('currentDate')
    currentDateChanged(v: Date) {
        if (this.tab == 'kanban') {
            this.makeDays();
        } else {
            this.loadItems();
        }
        this.setQuery('date', moment(v).format('YYYY-MM-DD'));
    }

    saveQuery() {
        this.setQuery('party', this.partyFilter);
        this.setQuery('district', this.districtFilter);
        this.setQuery('town', this.townFilter);
        this.setQuery('user', this.filterTenantUser ? this.filterTenantUser!.toString() : '');
        this.setQuery('category', this.filterCategory ? this.filterCategory!.toString() : '');
        this.setQuery('department', this.filterDepartment ? this.filterDepartment!.toString() : '');
        this.setQuery('position', this.filterPosition ? this.filterPosition!.toString() : '');
        this.setQuery('view', this.tab);
        this.setQuery('pageSize', this.pageSize?.toString());
        this.setQuery('date', moment(this.currentDate).format('YYYY-MM-DD'));
        this.setQuery('sortBy', this.sortBy);
        this.setQuery('sortDesc', this.sortDesc ? 'true' : 'false');
        window.localStorage.wtParty = this.partyFilter ?? '';
        window.localStorage.wtDistrict = this.districtFilter ?? '';
        window.localStorage.wtTown = this.townFilter ?? '';
        window.localStorage.wtUser = this.filterTenantUser?.toString() ?? '';
        window.localStorage.wtCategory = this.filterCategory?.toString() ?? '';
        window.localStorage.wtDepartment = this.filterDepartment?.toString() ?? '';
        window.localStorage.wtPosition = this.filterPosition?.toString() ?? '';
        window.localStorage.wtView = this.tab;
        window.localStorage.wtPageSize = this.pageSize?.toString();
        window.localStorage.wtSortBy = this.sortBy?.toString();
        window.localStorage.wtSortDesc = this.sortDesc?.toString();
    }

    clearFilters() {
        this.partyFilter = null;
        this.districtFilter = null;
        this.townFilter = null;
        this.filterTenantUser = null;
        this.filterCategory = null;
        this.filterPosition = null;
        this.filterDepartment = null;
        this.saveQuery();
    }

    created() {
        if (
            this.getQuery('view') != null ||
            this.getQuery('party') != null ||
            this.getQuery('district') != null ||
            this.getQuery('town') != null ||
            this.getQuery('user') != null ||
            this.getQuery('pageSize') != null ||
            this.getQuery('date') != null ||
            this.getQuery('sortBy') != null ||
            this.getQuery('sortDesc') != null
        ) {
            this.tab = this.getQuery('view') ?? 'kanban';
            this.partyFilter = this.getQuery('party');
            this.districtFilter = this.getQuery('district');
            this.townFilter = this.getQuery('town');
            this.filterTenantUser = this.getQuery('user') ? this.getQuery('user')!.split(',') : null;
            this.filterCategory = this.getQuery('category')
                ? this.getQuery('category')!
                      .split(',')
                      .filter((x: string) => x.toString().length > 0)
                : null;
            this.filterDepartment = this.getQuery('department') ? this.getQuery('department')!.split(',') : null;
            this.filterPosition = this.getQuery('position') ? this.getQuery('position')!.split(',') : null;
            this.pageSize = this.getQueryInt('pageSize') ?? 25;
            this.currentDate = moment(this.getQuery('date')).isValid()
                ? moment(this.getQuery('date')).toDate()
                : moment().startOf('isoWeek').toDate();
            this.dateFilter = moment(this.getQuery('date')).isValid()
                ? moment(this.getQuery('date')).toDate()
                : moment().startOf('isoWeek').toDate();
            this.sortBy = this.getQuery('sortBy') ?? 'time';
            this.sortDesc = this.getQuery('sortDesc') == 'true' ?? false;
        } else {
            this.tab = window.localStorage.wtView ?? 'kanban';
            this.partyFilter = window.localStorage.wtParty ?? null;
            this.districtFilter = window.localStorage.wtDistrict ?? null;
            this.townFilter = window.localStorage.wtTown ?? null;
            this.filterTenantUser = window.localStorage.wtUser?.split(',') ?? null;
            this.filterCategory =
                window.localStorage.wtCategory?.split(',').filter((x: string) => x.toString().length > 0) ?? null;
            this.filterDepartment = window.localStorage.wtDepartment?.split(',') ?? null;
            this.filterPosition = window.localStorage.wtPosition?.split(',') ?? null;
            if (window.localStorage.wtPageSize && Number(window.localStorage.wtPageSize)) {
                this.pageSize = Number(window.localStorage.wtPageSize);
            }
            this.currentDate = moment().startOf('isoWeek').toDate();
            this.dateFilter = moment().startOf('isoWeek').toDate();
            this.sortBy = window.localStorage.wtSortBy ?? 'time';
            this.sortDesc = window.localStorage.wtSortDesc == 'true';
            this.saveQuery();
        }
    }

    mounted() {
        this.makeDays();
        //this.loadItems();
        if (this.mySwiper) {
            const index = moment().isoWeekday() - 1;
            this.mySwiper.$swiper.slideTo(index);
        }
    }

    nextWeek() {
        this.currentDate = moment(this.currentDate).add(1, 'week').toDate();
        this.dateFilter = this.currentDate;
    }

    prevWeek() {
        this.currentDate = moment(this.currentDate).add(-1, 'week').toDate();
        this.dateFilter = this.currentDate;
    }

    nextMonth() {
        this.currentDate = moment(this.currentDate).add(1, 'month').startOf('month').toDate();
        this.dateFilter = this.currentDate;
    }

    prevMonth() {
        this.currentDate = moment(this.currentDate).add(-1, 'month').startOf('month').toDate();
        this.dateFilter = this.currentDate;
    }

    makeDays() {
        this.kanbanItems = [];
        let since = moment(this.currentDate).toDate();
        const until = moment(since).add(7, 'day').toDate();
        this.since = since;
        this.until = until;
        while (since < until) {
            this.kanbanItems.push({
                id: moment(since).format('YYYY-MM-DD'),
                date: since,
            } as WorkTaskKanbanColumnModel);
            since = moment(since).add(1, 'day').toDate();
        }
    }

    getPredicates() {
        const filterPredicates = [
            { field: 'time', op: 'gte', comparand: moment(this.currentDate).startOf('month').toDate() },
            { field: 'time', op: 'lte', comparand: moment(this.currentDate).add(1, 'year').endOf('month').toDate() },
        ] as any;
        let userFilters: CrudQueryPredicate[] = [];
        let departmentFilters: CrudQueryPredicate[] = [];
        let positionFilters: CrudQueryPredicate[] = [];
        if (this.filterCategory && this.filterCategory.length > 0) {
            filterPredicates.push({
                field: 'audit.categoryId',
                op: 'in',
                comparand: this.filterCategory,
            });
        }
        if (this.filterOnlyMine) {
            filterPredicates.push({
                field: 'planItemAuditTenantUsers.tenantUserId',
                op: 'eq',
                comparand: this.tenantUser.id,
            });
        } else {
            if (this.filterTenantUser && this.filterTenantUser.length > 0) {
                this.filterTenantUser.forEach((e: string) => {
                    if (e) {
                        userFilters.push({
                            field: 'planItemAuditTenantUsers.tenantUserId',
                            op: 'eq',
                            comparand: e,
                            junction: 'or',
                        });
                    }
                });
            }
            if (this.filterDepartment && this.filterDepartment.length > 0) {
                this.filterDepartment.forEach((e: string) => {
                    if (e) {
                        departmentFilters.push({
                            field: 'tenantUser.departmentId',
                            op: 'eq',
                            comparand: e,
                            junction: 'or',
                        });
                    }
                });
            }
            if (this.filterPosition) {
                this.filterPosition.forEach((e: string) => {
                    if (e) {
                        positionFilters.push({
                            field: 'tenantUser.positionId',
                            op: 'eq',
                            comparand: e,
                            junction: 'or',
                        });
                    }
                });
            }
        }
        if (userFilters.length > 0) {
            filterPredicates.push({
                field: 'planItemAuditTenantUsers.tenantUserId',
                op: 'wrap',
                comparand: userFilters,
            });
        }
        if (departmentFilters.length > 0) {
            filterPredicates.push({
                field: 'tenantUser.departmentId',
                op: 'wrap',
                comparand: departmentFilters,
            });
        }
        if (positionFilters.length > 0) {
            filterPredicates.push({
                field: 'tenantUser.positionId',
                op: 'wrap',
                comparand: positionFilters,
            });
        }
        return filterPredicates;
    }

    loadItems() {
        planItemsStore.dispatch(
            CrudAction.GetAllBasic,
            createCrudQueryPayload<PlanItemModel>(
                [{ field: this.sortBy, index: 1, order: this.sortDesc ? 'desc' : 'asc' }],
                this.getPredicates(),
                {
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                },
                false,
                'WorkTaskItems-' + moment(this.currentDate).format('YYYY-MM-DD')
            )
        );
    }

    openCalendarDialog() {
        this.calendarDialog.open();
    }

    deletePlanItemClick(item: PlanItemModel) {
        this.deletePlanItemDialog = true;
        this.deletePlanItemModel = item;
    }

    deletePlanItem() {
        planItemsStore.dispatch(CrudAction.Delete, { id: this.deletePlanItemModel!.id! });
        this.subscribe(planItemsStore, CrudReponse.Delete).then(() => {
            this.deletePlanItemDialog = false;
            this.loadItems();
        });
    }

    workTaskCreated(e: PlanItemModel) {
        if (this.tab == 'table') {
            this.loadItems();
        }
        /*else {
			this.kanbanColumns.firstOrDefault(x => moment(x.date).startOf('day').isSame(moment(e.time).startOf('day')))?.refresh();
		}*/
    }

    setShowInfo(code: WorkTasksShowDetailTypeEnum): void {
        const show = !this.getShowInfo(code);
        workTasksShowDetailsStore.dispatch(code, show);
    }

    getShowInfo(code: WorkTasksShowDetailTypeEnum): boolean {
        return workTasksShowDetailsStore.useGetter(code);
    }

    openDeactivateDialog(item: any) {
        this.deactivatePlanItemModel = item;
        this.deactivatePlanItemDialog = true;
    }

    openReactivateDialog(item: any) {
        this.reactivatePlanItemModel = item;
        this.reactivatePlanItemDialog = true;
    }

    async confirmDeactivatePlanItem() {
        if (!this.deactivatePlanItemModel) return;
        this.deactivateLoading = true;
        const id = this.deactivatePlanItemModel.id;
        const key = 'DeactivatePlanItem-' + id;
        await planItemsStore.dispatch(CrudAction.Get, { id, key });
        const item = planItemsStore.useGetter(CrudGetter.Detail, key);
        if (item) {
            item.isDeactivated = true;
            await planItemsStore.dispatch(CrudAction.Update, { key, item });
        }
        this.deactivateLoading = false;
        this.deactivatePlanItemDialog = false;
        this.deactivatePlanItemModel = null;
    }

    async confirmReactivatePlanItem() {
        if (!this.reactivatePlanItemModel) return;
        this.reactivateLoading = true;
        const id = this.reactivatePlanItemModel.id;
        const key = 'ReactivatePlanItem-' + id;
        await planItemsStore.dispatch(CrudAction.Get, { id, key });
        const item = planItemsStore.useGetter(CrudGetter.Detail, key);
        if (item) {
            item.isDeactivated = false;
            await planItemsStore.dispatch(CrudAction.Update, { key, item });
        }
        this.reactivateLoading = false;
        this.reactivatePlanItemDialog = false;
        this.reactivatePlanItemModel = null;
    }

    exportClick() {
        const filters = this.getPredicates();
        this.downloading = true;
        ApiService.api
            .exportPlanItemBatch(1, 999999, {
                predicates: filters,
                orderby: [{ field: 'time', index: 1, order: SortOrder.Desc }],
            })
            .then((e) => {
                const res = e.data.returnValue!;
                const blob = b64toBlob(res.base64!, res.contentType!);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', res.filename!);
                document.body.appendChild(link);
                link.click();
                link.parentNode!.removeChild(link);
                this.downloading = false;
            })
            .catch(() => {
                this.downloading = false;
            });
    }
}
